<template>
	<div>
		<div class="cont">
			<Breadcrumb :pathList="pathList"></Breadcrumb>
			<div style="margin-top: 20px;" v-html="info"></div>
			<!-- <div class="t" style="margin-top: 20px;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean
				euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin
				sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur
				ridiculus mus. 
				Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida
				dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis
				natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Lorem ipsum dolor sit amet,
				consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus
				accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis
				dis parturient montes, nascetur ridiculus mus. 
				Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida
				dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis
				natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. </div>
			<img src="../../assets/images/home/logo.png" style="width: 608px;height: 353px;border-radius: 13px;" />
			<div class="t">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.
				Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum
				sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. 
				Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida
				dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis
				natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. </div> -->
		</div>
		<toTop></toTop>
		<Footer></Footer>
	</div>
</template>

<script>
	import {
		about
	} from "@/api/common";
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import Footer from '../../components/Footer.vue'
	import toTop from '../../components/toTop.vue'
	export default {
		data() {
			return {
				pathList: [{
					title: '首页',
					path: '/index'
				}, {
					title: '关于S学苑',
					path: ''
				}],
				info:''
			}
		},
		components: {
			Breadcrumb,
			Footer,
			toTop
		},
		mounted() {
			this.getAbout()
		},
		methods:{
			async getAbout(){
				const {
					status,
					data
				} = await about({});
				this.info=data.result.value
			}
		}
	}
</script>

<style lang="less" scoped>
	::v-deep p{
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 16px !important;
		color: #333333 !important;
		line-height: 30px !important;
	}
	.cont {
		min-height: 100vh;
		padding: 30px 133px 0;
		.t {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #333333;
			line-height: 30px;
		}

		img {
			margin: 10px 0;
		}
	}
	::v-deep img{
		width: 100%;
	}
</style>